import script from "./HistoryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryButton.vue?vue&type=script&setup=true&lang=js"

import "./HistoryButton.vue?vue&type=style&index=0&id=722459ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722459ec"]])

export default __exports__